require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./data-visualization-data-visualization-with-d-3-invert-svg-elements.json") })
        }
      }, "path---data-visualization-data-visualization-with-d-3-invert-svg-elements");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---data-visualization-data-visualization-with-d-3-invert-svg-elements!./.cache/json/data-visualization-data-visualization-with-d-3-invert-svg-elements.json
// module id = 1972
// module chunks = 231608221292675